import { ValueOfKey } from '../../utils-types';

export const DISCOUNT_TYPE = {
  NOT_APPLIED: 'NOT_APPLIED',
  PROMOCODE: 'PROMOCODE',
} as const;

export type DiscountType = ValueOfKey<typeof DISCOUNT_TYPE>;
